import React, { FC, useEffect } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { Trans } from 'react-i18next'

const ClearingAccountPreferencesForm: FC<FormProps> = props => {
  const submitForm = ({ data, options }: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit({ data, options })
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    configData,
    toggleShowByName,
  } = useForm(
    props.fetchedData,
    config,
    submitForm
  )

  useEffect(() => {
    toggleShowByName(
      'londonMetalExchange',
      formData.engageInClearedBusiness.value === 'true'
    )
    toggleShowByName(
      'frieghtDerivatives',
      formData.engageInClearedBusiness.value === 'true'
    )
    toggleShowByName(
      'iceClearEurope',
      formData.engageInClearedBusiness.value === 'true'
    )

  }, [formData.engageInClearedBusiness.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.title')}
        </FormTitle>
        <FormDescription bold>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.description' />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation ||
              (
                formData.engageInClearedBusiness.value === 'true' &&
                (
                  formData.londonMetalExchange.value === '' && formData.frieghtDerivatives.value === '' && formData.iceClearEurope.value === ''
                )
              )}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default ClearingAccountPreferencesForm
